<template>
  <div>
    <!-- <loader ref="loader" :isVisible="loading"></loader> -->
    <router-view/>
  </div>
</template>
<script>
// import Loader from '@/components/Loader'
// import { mapState } from 'vuex'

export default {
  // components: { Loader },
  // computed: {
  //   ...mapState('loader', [
  //     'loading'
  //   ])
  // }
  created () {
    // document.title = 'Dashboard SPKLU KTT G20'
    // document.title = 'Dashboard SPKLU'
  }
}
</script>
